<template>
  <button
    class="TagFollowButton btn button-default"
    :class="{ '-following': following }"
    type="button"
    :aria-pressed="following ? 'true' : 'false'"
    :disabled="busy"
    @click="toggle"
  >
    {{ following ? $t('tags.unfollow') : $t('tags.follow') }}
  </button>
</template>

<script>
import { useFollowedTagsStore } from 'src/stores/followed_tags.js'

// Follow a hashtag: its posts then come into the home timeline.
export default {
  props: {
    tag: { type: String, required: true },
  },
  data: () => ({ busy: false }),
  computed: {
    following() {
      return useFollowedTagsStore().isFollowed(this.tag)
    },
  },
  created() {
    useFollowedTagsStore().ensureLoaded()
  },
  methods: {
    async toggle() {
      const store = useFollowedTagsStore()
      this.busy = true
      try {
        await (this.following
          ? store.unfollow(this.tag)
          : store.follow(this.tag))
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style lang="scss">
.TagFollowButton {
  padding: 0 0.9em;
  white-space: nowrap;
}
</style>
